const REAIS = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

/**
 * Um valor em reais, como o termo de recebimento o escreve.
 *
 * **Nulo devolve nulo, e nunca "R$ 0,00".** Zero é o resultado de quem não teve desconto; nulo é o
 * resultado de ninguém ter registrado sobre quanto o percentual incide. É a mesma distinção do
 * indicador não apurado, e ela aparece num documento que alguém assina.
 *
 * @param valor o valor, ou nulo
 * @returns o valor escrito em pt-BR, ou nulo
 */
export function reais(valor: number | null | undefined): string | null {
  return valor == null ? null : REAIS.format(valor)
}

/** Um número escrito com ponto de milhar e sem centavos: "219.444", "1.005.000". */
const SO_MILHAR = /^\d{1,3}(\.\d{3})+$/

/**
 * "219.444,44" e "219444.44" viram o mesmo número.
 *
 * **O ponto é ambíguo em pt-BR, e o desempate é explícito.** Com vírgula presente, ela é o decimal e
 * todo ponto é milhar — é como o documento escreve. Sem vírgula, o ponto só é milhar quando agrupa
 * exatamente três dígitos ("219.444"); caso contrário ele é o decimal, que é como chega o valor
 * colado de uma planilha ("219444.44"). "1.005" é mil e cinco, como se lê em pt-BR; quem precisa
 * do milésimo escreve "1,005". Adivinhar em silêncio aqui é como um valor unitário vira mil vezes
 * ele mesmo.
 *
 * **Mora em `lib/` porque o defeito que ela evita não é do formulário de ordem de serviço.** Ela
 * nasceu ali, e enquanto ficou ali o cartão do valor da nota e os nove campos do IIE usaram
 * `Number(texto.replace(',', '.'))` — que troca só a PRIMEIRA vírgula e não sabe nada de milhar.
 * Nessa leitura, `"180.000"` é 180: a glosa de 10% saía R$ 18,00 num papel que vai para processo
 * administrativo, e `"1.200"` backups viravam 1. Quem precisar ler número digitado à mão em
 * qualquer tela nova importa daqui.
 *
 * @param texto o valor como foi digitado
 * @returns o número, ou `NaN` quando não é um
 */
export function paraNumero(texto: string): number {
  if (texto.includes(',')) {
    return Number(texto.replace(/\./g, '').replace(',', '.'))
  }
  return Number(SO_MILHAR.test(texto) ? texto.replace(/\./g, '') : texto)
}
